import { Pipe, PipeTransform } from '@angular/core';
import { CacheService } from '../../../services/sys/cache.service';

@Pipe({
    name: 'yesNoBoolean',
    standalone: false
})
export class YesNoBoolean implements PipeTransform {
    
    constructor(private cacheService: CacheService) {}
    
	transform(value : boolean): string {
		if (value == true) {
            return this.cacheService.getDropDownTextFromVal("OptionText.YesNoChoices", "1");
        } else if (value == false) {
            return this.cacheService.getDropDownTextFromVal("OptionText.YesNoChoices", "2");
        } else {
            return "";
        }
	}
    
}